<style lang="scss" scoped>
.slide-7 {
  background-image: url("../../../assets/module1/slide7/background-01.jpg");
  background-size: cover;
  background-position: center;
  padding-top: 75px;
  height: calc(100% - 75px);
  padding-left: 140px;
  padding-right: 140px;
}
h1 {
  font-size: 80px;
  transform: rotate(-2deg);
  span {
    color: #98d5c0;
  }
}
h2 {
  font-size: 64px;
  color: #c5d43b;
  margin-top: 25px;
  transform: translateX(-41px);
  white-space: nowrap;
}
p {
  color: white;
}
.left p {
  max-width: 377px;
  margin-top: 60px;
}
.left {
  margin-right: 60px;
}
</style>

<template>
  <div class="slide-7">
    <transition name="fadeRight" appear>
      <img
        class="chars delay-4"
        v-show="slideIndex == 6"
        src="@/assets/module1/slide7/photos-01.png"
      />
    </transition>
    <div class="flex">
      <div class="flex-1 left">
        <transition name="fadeUp" appear>
          <div v-show="slideIndex == 6">
            <h1 v-html="$t('module1.slide7.heading')"></h1>
          </div>
        </transition>
        <transition name="fadeUp" appear>
          <div class="delay-1" v-show="slideIndex == 6">
            <h2>{{ $t("module1.slide7.heading2") }}</h2>
          </div>
        </transition>
        <transition name="fadeUp" appear>
          <div class="delay-2" v-show="slideIndex == 6">
            <p>{{ $t("module1.slide7.paragraph") }}</p>
          </div>
        </transition>
      </div>
      <div class="flex-1 right">
        <transition name="fadeUp" appear>
          <div class="delay-3" v-show="slideIndex == 6">
            <p v-html="$t('module1.slide7.paragraph2')"></p>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
